import React, { forwardRef } from 'react';
import clsx from 'clsx';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean | string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, error, ...props },
  ref
) {
  const isInvalid = Boolean(error);
  return (
    <input
      ref={ref}
      className={clsx('input-base', isInvalid && 'input-error', className)}
      aria-invalid={isInvalid || undefined}
      {...props}
    />
  );
});

export default Input; 